//var crdebug = true;
var specialProduct1 = false;
var noSpecial1 = false;
var crValidateDelivery = true;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  if (itemTitle?.toLowerCase().indexOf('delivery order') > -1) continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Shipping'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } else {
    noSpecial1 = true;
  }  
}

//exclude delivery another method, created for victoria-yum
var disabledDelivery = false;
for (var crItem of crItems) {
  const collections = crItem?.collections?.toLowerCase()
  //if (collections.indexOf('Swine Club'.toLowerCase()) > -1) disabledDelivery = true;
  
}

document.addEventListener('crJQActivated', function (e) {
  

  if (disabledDelivery === true) {
    jqCR('.pickup-wrapper').remove();
    //jqCR('#6875648852045').hide()
    setTimeout(function(){    
      var productData = {quantity: 0,id: deliveryProduct};
      jqCR.post('/cart/change.js', productData, function(res, err) {console.log('refresh')})
    }, 1000)
  } else if ( noSpecial1 === true) {
    var crValidateDelivery = true
    storePickupSettings.shippingEnabled = false;
    document.querySelector('.cr-shipping-method').style.display = 'none'
  }
})



// **** Better way to set special products in one place **** ////
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Swine Club'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct2 === true) {    
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2034, 11, 31] }, 
                           //[2025,3,2, 'inverted'],
                           //[2025,5,5, 'inverted'],
                           [2025,6,3, 'inverted'],
                           [2025,9,2, 'inverted'],
                          ]);
    picker.set('max', 180);   
  }	else {
    picker.set('disable', blackoutdatesCollection);
  }  
}

var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  if (specialProduct2 === true) {
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2034, 11, 31] }, 
                           [2025,3,2, 'inverted'],
                           [2025,6,2, 'inverted'],
                           [2025,9,1, 'inverted'],
                          ]);
    picker.set('max', 180);   
  } else {    
    picker.set('disable', blackoutdatesCollection);
  }  
}
